//Headroom plugin
function stickyNavAnim () {
    const nav = document.querySelector( ".section-header" );
    if ( !nav ) {
        return;
    }

    let onTopFirstTime = true;

    const headroom = new Headroom( nav, {
        offset: 650,
        tolerance: 10,
        classes: {
            initial: "section-header--sticky-animation",
            pinned: "section-header--sticky-animation--pinned",
            unpinned: "section-header--sticky-animation--unpinned",
            top: "section-header--sticky-animation--top",
            notTop: "section-header--sticky-animation--not-top",
            bottom: "section-header--sticky-animation--bottom",
            notBottom: "section-header--sticky-animation--not-bottom",
            frozen: "section-header--sticky-animation--frozen",
        },
        onPin : function() {
            nav.classList.add("section-header--fixed");
            setTimeout(() => {
                nav.classList.remove("section-header--absolute");
            }, 250);
            document.body.classList.add("navbar-is-pinned");
        },
        onTop : function() {
            if(!onTopFirstTime) {
                nav.classList.add("section-header--hidden");
                setTimeout(() => {
                    nav.classList.remove("section-header--hidden");
                }, 250);
            }
            onTopFirstTime = false;

            setTimeout(() => {
                nav.classList.remove("section-header--fixed");
            }, 250);
        },
        onUnpin : function() {
            document.body.classList.remove("navbar-is-pinned");
        },
    } );
    headroom.init();
}

document.addEventListener("DOMContentLoaded", function() {
    stickyNavAnim()

    const stickyBuy = document.querySelector('.product-sticky-buy');
    
    $(window).scroll(function() {
        const scrollHeight = $(window).scrollTop();
        const announcementHeight = $(".section-announcement").outerHeight();
        
        // if (scrollHeight > announcementHeight) {
        //     $(".section-header").addClass("section-header--fixed");
        // } else {
        //     $(".section-header").removeClass("section-header--fixed");
        // }
        
        if (stickyBuy) {
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            const threshold = 20;
            
            if (documentHeight - (scrollHeight + windowHeight) <= threshold) {
                stickyBuy.style.transform = 'translateY(100%)';
                stickyBuy.style.opacity = '0';
            } else {
                stickyBuy.style.transform = 'translateY(0)';
                stickyBuy.style.opacity = '1';
            }
        }
    });

    // Shared state to track currently active menu
    let activeMenuId = null;
    let menuTimeouts = {};
    
    // Close all other menus except the active one
    function closeOtherMenus(currentMenuId) {
        $('.grandparent').each(function() {
            const thisMenuId = $(this).data('menu-id') || $(this).index();
            
            if (thisMenuId !== currentMenuId) {
                const $dropdown = $(this).find('.mega-menu-dropdown');
                const $headerMenu = $(this).find('.header-menu__url');
                
                $dropdown.removeClass('open');
                $headerMenu.removeClass('open');
                
                // Clear any pending timeouts for this menu
                if (menuTimeouts[thisMenuId]) {
                    clearTimeout(menuTimeouts[thisMenuId]);
                    delete menuTimeouts[thisMenuId];
                }
            }
        });
    }

    $('.grandparent').on('mouseenter', function() {
        const $this = $(this);
        const menuId = $this.data('menu-id') || $this.index();
        
        // Cancel any pending close operations
        if (menuTimeouts[menuId]) {
            clearTimeout(menuTimeouts[menuId]);
            delete menuTimeouts[menuId];
        }
        
        // If we're entering a new menu, close all other menus immediately
        if (activeMenuId !== menuId) {
            closeOtherMenus(menuId);
        }
        
        // Update active menu tracking
        activeMenuId = menuId;
        
        // Add appropriate classes to show this menu
        $this.find('.mega-menu-dropdown').addClass('open');
        $this.find('.header-menu__url').addClass('open');
        $this.closest('.shopify-section').addClass('mega-menu-open');
        $this.closest('.section-header').addClass('mega-menu-open');
    }).on('mouseleave', function() {
        const $this = $(this);
        const menuId = $this.data('menu-id') || $this.index();
        const $dropdown = $this.find('.mega-menu-dropdown');
        const $headerMenu = $this.find('.header-menu__url');
        
        // Start a timer to close the menu - but only if user isn't already in another menu
        menuTimeouts[menuId] = setTimeout(function() {
            // Check if user is hovering any grandparent item
            if (!$('.grandparent:hover').length) {
                $dropdown.removeClass('open');
                $headerMenu.removeClass('open');
                $this.closest('.shopify-section').removeClass('mega-menu-open');
                $this.closest('.section-header').removeClass('mega-menu-open');
                activeMenuId = null;
            }
            delete menuTimeouts[menuId];
        }, 300);
    });
});